import { render, staticRenderFns } from "./CourseInfoModal.html?vue&type=template&id=7d18f108&scoped=true&external"
import script from "./CourseInfoModal.vue?vue&type=script&lang=js"
export * from "./CourseInfoModal.vue?vue&type=script&lang=js"
import style0 from "./CourseInfoModal.scss?vue&type=style&index=0&id=7d18f108&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d18f108",
  null
  
)

export default component.exports